import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_11: DocMigration = {
  maxSchemaVersion: "0.0.11",
  apply(json: any) {
    if (json.settings) {
      json.settingsOverride = json.settings;
    }

    if (json.elevations) {
      for (const id in json.elevations) {
        const elevation = json.elevations[id];
        if (elevation.settings) {
          elevation.settingsOverride = elevation.settings;
          delete elevation.settings;
        }

        if (elevation.defaultExteriorPalette) {
          const customPalette = json?.tables?.palettes?.[elevation.defaultExteriorPalette];

          if (customPalette) {
            // the user has loaded a palette from the legacy format
            delete customPalette.type;
            json.tables.settings[elevation.defaultExteriorPalette] = {
              type: "EXTERIOR_MATERIAL_SETTINGS",
              name: customPalette.name,
              ...customPalette.materials,
            };
            elevation.settingsOverride.exteriorMaterials = elevation.defaultExteriorPalette;
            elevation.baseSettings = "Default";
          } else {
            elevation.baseSettings = elevation.defaultExteriorPalette;
          }

          delete elevation.defaultExteriorPalette;
        }
      }
    }

    for (const blockId in json.blocks) {
      const block = json.blocks[blockId];
      for (const layoutId in block.layouts) {
        const layout = block.layouts[layoutId];
        for (const locationId in layout.rooms) {
          const room = layout.rooms[locationId];
          if (!room.layout || !room.layout.openingPatterns) {
            continue;
          }

          for (const openingPattern of room.layout.openingPatterns) {
            for (const opening of openingPattern.openings) {
              if (opening.headCasing) {
                opening.exteriorHeadCasing = opening.headCasing;
                delete opening.headCasing;
              }
            }
          }
        }
      }
    }

    return json;
  },
};

export default migration_0_0_11;
